<template>
  <v-dialog v-model="dialog" persistent max-width="600px">
    <v-card>
      <v-card-title>
        <app-title> Tem certeza que quer deletar essa sessão? </app-title>
      </v-card-title>
      <v-card-text>
        <div v-if="isFromGroup">
          <v-switch v-model="form.delete_sessions" class="pb-0 mt-0" :true-value="1" :false-value="0" hide-details
            :label="' Deletar também as sessões futuras deste pacote'" />
        </div>
        <div class="mt-4" v-if="!isCustomEvent">
          <v-switch v-if="canDeleteTransactions" v-model="form.delete_transactions" :true-value="1" :false-value="0"
            class="pb-0" hide-details :label="' Deletar também os registros financeiros?'" />
        </div>
      </v-card-text>
      <v-card-actions class="d-flex justify-space-between">
        <v-btn color="error" @click="handleDelete()" rounded> Deletar </v-btn>
        <v-btn outlined rounded @click="dialog = false" text> voltar </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    session: {},
  },

  data: () => ({
    dialog: false,

    form: {
      delete_sessions: 0,
      delete_transactions: 0,
    },
  }),

  computed: {
    isFromGroup() {
      return this.session.session_group.repetitions_count > 1;
    },

    isTransactionFromFormGroup() {
      return this.session.transactions.length == 0;
    },

    canDeleteTransactions() {
      if (this.isTransactionFromFormGroup) {
        return this.form.delete_sessions;
      }

      return true;
    },
    isCustomEvent() {
      return this.session.session_group.session_type == 'custom_event'
    },
  },

  methods: {
    open() {
      this.reset();
      this.dialog = true;
    },

    reset() {
      this.form.delete_sessions = 0;
      this.form.delete_transactions = 0;
    },

    async handleDelete() {
      this.$loading.start();
      await this.$http
        .destroy("sessions/session", this.session.id, this.form)
        .then((response) => {
          this.$loading.finish();
          this.$emit("delete");
          this.dialog = false;
        })
        .catch((error) => {
          this.$loading.finish();
        });
    },
  },
};
</script>

<style></style>
